var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H13",
    stroke: "#323232",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5V12.5",
    stroke: "#323232",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10C3 3.82375 4.32375 2.5 10.5 2.5C16.6762 2.5 18 3.82375 18 10C18 16.1762 16.6762 17.5 10.5 17.5C4.32375 17.5 3 16.1762 3 10Z",
    stroke: "#323232",
    strokeWidth: 2.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpayment);
export default __webpack_public_path__ + "static/media/addpayment.0df201fa64f5b20f32793dd6bfd601e8.svg";
export { ForwardRef as ReactComponent };